<template>
    <div>
      <div class="drop_block" tabindex="0" @focusout="openDropDown = false">
            <div class="current_active" @click="openDropDown = !openDropDown">
            <div class="d-flex align-items-center mr-2 select_text">
                <span>{{ selectedLabel || 'Please select' }}</span>
            </div>
            <div class="arr_box">
                <SvgHeaderSvg v-if="!openDropDown" :type="'down'" />
                <SvgHeaderSvg v-else :type="'up'" />
            </div>
            </div>
            <ul v-show="openDropDown" class="drop_item p-0">
                <li
                    v-for="option in currentOptions"
                    :key="option.value"
                    @click="handleSelect(option)"
                    :class="{ 'disabled': option.disabled,
                    'active': (props.type === 'price' || props.type === 'jewelry') && option.value === props.modelValue
                     }"
                    >
                    <span>{{ option.label }}</span>
                </li>
            </ul>
      </div>
    </div>
  </template>
  
<script setup>
    const router = useRouter();
    const route = useRoute();
    const openDropDown = ref(false);
    const localePath = useLocalePath();
    const props = defineProps(['type', 'modelValue','routeOptions','routecustom','sortOptions','priceOptions']);

    
    const emit = defineEmits(['update:modelValue','handleSelect','selectedLabel']);
    
    const currentOptions = computed(() => {
        if (props.type === 'price') {
            return props.priceOptions;
        }
        if (props.type === 'jewelry') {
            return props.sortOptions;
        }
        if (props.type === 'policymenu') {
            return Object.keys(props.routeOptions).map((key) => ({
                value: key,
                label: props.routeOptions?.[key],
            }));
        }
        if (props.type === 'custompolicy') {
            return Object.keys(props.routecustom).map((key) => ({
                value: key,
                label: props.routecustom?.[key],
            }));
        }
        return [];
    });
    
    const selectedLabel = computed(() => {
        let routePath = route.path;
            if (routePath?.includes('/in/')) {
                if (props.type === 'policymenu') {
                    routePath = route.path.replace('/in/', '');
                } 
                else if (props.type === 'custompolicy') {
                    routePath = route.path.replace('/in/customer-service/', '/customer-service/');
                }
            }
            if (props.type === 'policymenu') {
                const currentRouteOptions = props.routeOptions?.[routePath];
                return currentRouteOptions ? currentRouteOptions : routePath;
            } 
            if (props.type === 'custompolicy') {
                const currentRoute = props.routecustom?.[routePath];
                return currentRoute ? currentRoute : routePath; 
            }
            // for rest of dropdown
            else {
                const selectedOption = currentOptions?.value?.find((option) => option.value === props.modelValue);
                openDropDown.value = false;
                return selectedOption ? selectedOption.label : 'Select';
            }
    });

    const handleSelect = (option) => {
        if (props.type === 'policymenu') {
            router.push({ path: localePath( option?.value ) })
        }
        else if(props.type === 'custompolicy') {
            router.push({ path: localePath( option?.value ) })
        }
        else {
            emit('update:modelValue',  option?.value ); 
        }
        openDropDown.value = false
    };

</script>
  

<style scoped>
.label_box a .svg-head {
    margin: 0 0 -2px 9px;
}
p{
    font-size: 12px;
    font-weight: 600;
}
p a{
    color: var(--green);
}
.arr_box svg.svg-head {
    height: 16px;
}
.drop_block.invalid .current_active {
    border: 1px solid rgb(255, 2, 2);
}
.label_box {
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    color: #212529;
}
.label_box div{
    color: rgb(159, 158, 158);
    cursor: pointer;
}
.drop_block{
    position: relative;
}
.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
    border-radius: 8px;
}

label {
    font-size: 16px;
    color: #303030;
    line-height: 1.3;
}
.current_active.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}
ul {
    border: 1px solid #c4c4c4;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
    padding: 10px 0;
    max-height: 220px;
    overflow: auto;
    border-radius: 8px;
}
ul li{
    list-style: none;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
}
ul li.active{
    background: rgba(204,204,204,0.36863);
}
span{
    font-weight: 400;
    font-size: 14px;
    color: #212529; 
    text-transform: capitalize;
}


ul li.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.disabled {
    pointer-events: none;
    opacity: 0.5; 
}


@media(max-width: 767px){
    label {
        font-size: 14px;
        /* margin-bottom: 5px !important; */
    }
    .label_box {
        font-size: 14px;
        font-weight: 600;
        /* margin-bottom: 0 !important; */
    }
}

</style>
